module.exports = __webpack_public_path__ + "static/media/screen2.da7af678.png";